import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Calendar, ThumbsUp } from 'lucide-react'
import { formatCurrency, formatDate } from '@/lib/utils'

export default function ProgramadosTab({ processos, onAprovar }) {
  const parcelasProgramadas = []
  processos.forEach(processo => {
    if (processo.parcelas) {
      processo.parcelas.forEach(parcela => {
        if (parcela.status === 'programado') {
          parcelasProgramadas.push({
            ...parcela,
            processo_id: processo.id,
            processo_numero: processo.numero_processo,
            fornecedor: processo.fornecedor,
            numero_parcelas: processo.numero_parcelas
          })
        }
      })
    }
  })

  // Processos não-parcelados com status programado
  const processosProgramados = processos.filter(p => !p.parcelado && p.status === 'programado')

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-purple-600" />
          Programados
        </CardTitle>
        <CardDescription>
          Processos e parcelas programadas aguardando aprovação para pagamento
        </CardDescription>
      </CardHeader>
      <CardContent>
        {(parcelasProgramadas.length === 0 && processosProgramados.length === 0) ? (
          <div className="flex flex-col items-center justify-center h-40 text-slate-500">
            <Calendar className="w-12 h-12 mb-4 text-slate-300" />
            <p>Nenhum item programado</p>
            <p className="text-sm text-slate-400">Processos e parcelas programadas aparecerão aqui</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead>Processo</TableHead>
                  <TableHead>Fornecedor</TableHead>
                  <TableHead className="text-center">Parcela</TableHead>
                  <TableHead className="text-right">Valor</TableHead>
                  <TableHead>Fonte</TableHead>
                  <TableHead className="text-center">Previsão</TableHead>
                  <TableHead className="text-center">Ação</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {processosProgramados.map((p) => (
                  <TableRow key={`full-${p.id}`} className="hover:bg-purple-50">
                    <TableCell className="font-medium">{p.numero_processo}</TableCell>
                    <TableCell>{p.fornecedor}</TableCell>
                    <TableCell className="text-center">
                      <Badge variant="outline" className="bg-slate-100 text-slate-600 border-slate-300">
                        Integral
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right font-semibold text-teal-700">
                      {formatCurrency(p.valor)}
                    </TableCell>
                    <TableCell>{p.fonte_recurso || '-'}</TableCell>
                    <TableCell className="text-center">
                      {p.previsao_pagamento ? formatDate(p.previsao_pagamento) : '-'}
                    </TableCell>
                    <TableCell className="text-center">
                      <Button
                        size="sm"
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        onClick={() => onAprovar({ tipo: 'processo', processo_id: p.id })}
                        data-testid={`btn-aprovar-processo-programado-${p.id}`}
                      >
                        <ThumbsUp className="w-4 h-4 mr-1" />
                        Aprovar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {parcelasProgramadas.map((item, index) => (
                  <TableRow key={`${item.processo_id}-${item.numero}`} className="hover:bg-purple-50">
                    <TableCell className="font-medium">{item.processo_numero}</TableCell>
                    <TableCell>{item.fornecedor}</TableCell>
                    <TableCell className="text-center">
                      <Badge variant="outline" className="bg-purple-100 text-purple-700 border-purple-300">
                        {item.numero}/{item.numero_parcelas}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right font-semibold text-teal-700">
                      {formatCurrency(item.valor)}
                    </TableCell>
                    <TableCell>{item.fonte_recurso || '-'}</TableCell>
                    <TableCell className="text-center">
                      {item.previsao_pagamento ? formatDate(item.previsao_pagamento) : '-'}
                    </TableCell>
                    <TableCell className="text-center">
                      <Button
                        size="sm"
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        onClick={() => onAprovar({ tipo: 'parcela', processo_id: item.processo_id, parcela_numero: item.numero })}
                        data-testid={`btn-aprovar-parcela-programada-${index}`}
                      >
                        <ThumbsUp className="w-4 h-4 mr-1" />
                        Aprovar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <div className="mt-4 p-3 bg-purple-50 rounded-lg flex justify-between items-center">
              <div className="text-sm text-purple-700">
                <span className="font-semibold">{processosProgramados.length + parcelasProgramadas.length}</span> item(ns) programado(s)
              </div>
              <div className="text-sm font-semibold text-purple-700">
                Total: {formatCurrency(
                  processosProgramados.reduce((sum, p) => sum + p.valor, 0) +
                  parcelasProgramadas.reduce((sum, p) => sum + p.valor, 0)
                )}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
